const piiBlockList = new Set(['email', '_hse', 'password'])

const redactPii = <T>(key: string, value: T): T | string => {
  if (piiBlockList.has(key)) {
    return '[REDACTED]'
  } else if (typeof value === 'string') {
    return value.replace(/(\\?"email\\?":\s*\\?")([^"\\]+)(\\?")/giu, '$1[REDACTED]$3')
  }
  return value
}

export const redactPiiFromObj = (baseObj: { [key: string]: unknown }) => {
  return Object.keys(baseObj).reduce((obj: { [key: string]: unknown }, key) => {
    obj[key] = redactPii(key, baseObj[key])
    return obj
  }, {})
}

export const redactPiiFromUrl = (url: string): string => {
  const urlObj = new URL(url)
  const params = new URLSearchParams(urlObj.search)
  for (const [key, value] of params.entries()) {
    params.set(key, redactPii(key, value))
  }

  return `${urlObj.pathname}?${params}`
}
